import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { getViolationImageData } from '../../../redux/actions'
import {
  captureUrlStatuses,
  getSourceDescription
} from '../../../utils'

import { NotificationToast } from './Toast'

import moment from 'moment'

import {
  Grid, Typography, List, ListItem, Button, Divider, Avatar, Card, CardHeader, CardContent, Tooltip, Menu, MenuItem, ListItemIcon, IconButton
} from '@material-ui/core'

import {
  ExpandMore, CancelPresentationRounded, ClearAllRounded, FileCopyRounded,
  VisibilityRounded, VisibilityOffRounded, AddCircleOutlineRounded, RotateLeftRounded
} from '@material-ui/icons'
import PartialQuarantineModal from '../modals/PartialQuarantineModal'
import { postRedactedQuarantine, updateRedactedQuarantine } from '../../../redux/actions/violations'

import { CopyToClipboard } from 'react-copy-to-clipboard'

const copyTypes = {
  USER: 'userName',
  WORKSTATION: 'workstationName',
  URL: 'url'
}

const truncateText = (input) => {
  if (input.length > 20) {
    return input.substring(0, 20) + '...'
  }
  return input
}

const isIPAddressCheck = (url) => {
  try {
    // Regular expression (v4 only) pattern for IP addresses
    const ipPattern = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/

    // Convert the URL string to a URL object
    const parsedUrl = new URL(url)

    // Get the hostname from the URL object
    const hostname = parsedUrl.hostname

    // Check if the hostname matches the IP address pattern
    return ipPattern.test(hostname)
  } catch (error) {
    // If there is an error, return false to fail gracefully
    return false
  }
}

export const DetailsSidebar = ({
  classes, capture, handleQuickFilter, violationAdditionalTerms,
  toggleTempView, canViewImage, tempView, captureUrlStatus, toggleFullQuarantine = () => { }, canRequestBlock,
  isDomainBlocked, onRequestBlock,
  getAvatarBackground, fireQuarantineSuccess = () => { }
}) => {
  const { severity, quarantined, redacted = false, violationID, s3URL } = capture
  const reportedAt = capture.reportedAt ? capture.reportedAt : 'N/A'
  const receivedAt = capture.receivedAt ? capture.receivedAt : 'N/A'
  const ipAddress = capture.station_ip ? capture.station_ip : 'N/A'

  const dispatch = useDispatch()

  const renderUnit = (capture) => {
    const arr = capture.units.map((unit) => unit.unitName)
    return arr.join('/ ')
  }

  const getCaptureUrlStatus = () => {
    switch (captureUrlStatus) {
      case captureUrlStatuses.APPROVED:
        return 'BLOCKED'
      case captureUrlStatuses.DENIED:
        return 'ALLOWED'
      case captureUrlStatuses.PENDING:
        return 'PENDING'
      default:
        return ''
    }
  }

  const getUrlStatusTooltip = (status) => {
    switch (status) {
      case captureUrlStatuses.APPROVED:
        return 'This domain has been blocked.'
      case captureUrlStatuses.DENIED:
        return 'This domain has been allowed.'
      case captureUrlStatuses.PENDING:
        return 'This domain is already pending review.'
      default:
        return ''
    }
  }

  // --- Quarantine Menu Controls --- //
  const [quarantineAnchorEl, setQuarantineAnchorEl] = useState(null)
  const quarantineOpen = Boolean(quarantineAnchorEl)

  const openQuarantineMenu = (e) => { setQuarantineAnchorEl(e.currentTarget) }
  const closeQuarantineMenu = () => { setQuarantineAnchorEl(null) }

  const [partialQuarantineOpen, setPartialQuarantineOpen] = useState(false)
  const [baseImageDataStr, setBaseImageDataStr] = useState('')

  const fireFetchImageDataFailure = () => {
    NotificationToast(true, 'Unable to fetch data for quarantine selection. Please try again later.')
  }

  const fireFetchImageDataSuccess = (rtrnData) => {
    const { imageData } = rtrnData
    setBaseImageDataStr(imageData)
    setPartialQuarantineOpen(true)
  }

  const openPartialQuarantineModal = (e, fetchOriginal = false) => {
    dispatch(getViolationImageData({ violationID, fetchOriginal }, fireFetchImageDataSuccess, fireFetchImageDataFailure))
  }
  const closePartialQuarantineModal = () => { setPartialQuarantineOpen(false) }

  const handlePartialQuarantine = (newData) => {
    const vioInfo = { violationID, s3URL, redactedImage: newData }
    const action = quarantined ? updateRedactedQuarantine : postRedactedQuarantine
    dispatch(action(vioInfo, fireQuarantineSuccess, () => { NotificationToast(true, 'Unable to update violation. Please try again later.') }))
  }

  const quarantineMenuOptions = [
    {
      option: 'quarantine-full',
      label: 'Full Quarantine',
      displayWhenQuarantined: false,
      displayWhenRedacted: false,
      permissionBased: false,
      actionHandler: toggleFullQuarantine,
      Icon: CancelPresentationRounded
    },
    {
      option: 'quarantine-partial',
      label: 'Partial Quarantine',
      displayWhenQuarantined: false,
      displayWhenRedacted: false,
      permissionBased: false,
      actionHandler: openPartialQuarantineModal,
      Icon: ClearAllRounded
    },
    {
      option: 'view-hide-image',
      label: `${!tempView ? 'View' : 'Hide'} Image`,
      displayWhenQuarantined: true,
      displayWhenRedacted: null,
      permissionBased: true,
      actionHandler: toggleTempView,
      Icon: tempView ? VisibilityOffRounded : VisibilityRounded
    },
    {
      option: 'add-to-partial-areas',
      label: 'Add Quarantine Areas',
      displayWhenQuarantined: true,
      displayWhenRedacted: true,
      permissionBased: false,
      actionHandler: openPartialQuarantineModal,
      Icon: AddCircleOutlineRounded
    },
    {
      option: 'reset-quarantine-areas',
      label: 'Reset Quarantine Areas',
      displayWhenQuarantined: true,
      displayWhenRedacted: true,
      permissionBased: true,
      actionHandler: (e) => { openPartialQuarantineModal(e, true) },
      Icon: RotateLeftRounded
    }
  ]

  // render the button and the menu options
  const renderQuarantineMenu = () => {
    return (
      <>
        <Button
          variant='contained'
          color='primary'
          onClick={(e) => { openQuarantineMenu(e) }}
          className='h-100'
          classes={{ containedPrimary: quarantined ? classes.buttonQuarantinedColor : classes.buttonColor }}
          fullWidth
          endIcon={<ExpandMore />}
          disabled={Boolean(quarantined && !redacted && !canViewImage)}
        >
          <Typography style={{ textTransform: 'none', fontSize: 14, fontWeight: 'bold', lineHeight: '1.3' }} noWrap>Quarantine</Typography>
        </Button>

        <Menu
          open={quarantineOpen}
          anchorEl={quarantineAnchorEl}
          onClose={closeQuarantineMenu}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center'
          }}
        >
          {quarantineMenuOptions.map(optionObj => {
            const { option, label, displayWhenQuarantined, displayWhenRedacted, permissionBased, actionHandler = () => { }, Icon } = optionObj
            // determine which options to render depending on the captures current quarantined state and quarantined type as well as the user's permissions
            const displayOption = Boolean(displayWhenQuarantined === quarantined && (displayWhenRedacted === null || displayWhenRedacted === redacted) && (!permissionBased || (permissionBased && canViewImage)))
            if (displayOption) {
              return (
                <MenuItem
                  key={option}
                  onClick={(e) => { closeQuarantineMenu(); actionHandler(e) }}
                  className={classes.quarantineMenuItem}
                >
                  <ListItemIcon><Icon /></ListItemIcon>
                  {label}
                </MenuItem>
              )
            }
            return false
          })}
        </Menu>
      </>
    )
  }

  const handleCopy = (copyType) => {
    NotificationToast(
      false,
      copyType === copyTypes.USER
        ? 'User Copied'
        : copyType === copyTypes.WORKSTATION
          ? 'Station Copied'
          : copyType === copyTypes.URL
            ? 'Website Copied'
            : '',
      false
    )
  }

  const renderCopyButton = (copyText, copyType) => {
    return (
      <Tooltip title='Copy' arrow placement='top'>
        <CopyToClipboard
          text={copyText}
          onCopy={() => { handleCopy(copyType) }}
        >
          <IconButton
            size='small'
            aria-label={`copy-${copyType}`}
          >
            <FileCopyRounded fontSize='inherit' />
          </IconButton>
        </CopyToClipboard>
      </Tooltip>
    )
  }

  return (
    <>
      <Card className={`w-100 mx-auto ${classes.sidebarContainer}`} style={{ backgroundColor: '#FFFFFF' }}>
        <CardHeader
          disableTypography
          style={{ padding: '1em .8em' }}
          title={
            <Grid container direction='row' item className='w-100 mx-auto my-auto' spacing={1}>
              <Grid item xs={8} className='py-0 pl-0'>
                {renderQuarantineMenu()}
              </Grid>

              <Grid item xs={4} className='py-0 pr-0' style={{ justifyContent: 'center', display: 'flex' }}>
                <Avatar variant='circle' className={`${getAvatarBackground(severity)}`}>{severity}</Avatar>
              </Grid>
            </Grid>
          }
        />

        <CardContent className='pt-0'>
          {/* Detail Header End */}

          {/* Detail List Start */}
          <Grid container direction='row' className='mx-auto w-100'>
            <List className='w-100 pt-0' dense>
              <ListItem disableGutters>
                {/* User Start */}
                <Grid item container direction='column' justify='center' className='w-100 mx-auto'>
                  <Grid item container direction='row' justify='center' alignItems='center'>
                    <Typography variant='body2' style={{ marginRight: '.2em' }}>User:</Typography>
                  </Grid>

                  <Grid item container direction='row' justify='center'>
                    {
                      capture?.username
                        ? (
                          <Grid item container justify='center' alignItems='flex-start'>
                            <Grid item>
                              {renderCopyButton(capture.username, copyTypes.USER)}
                            </Grid>
                            <Grid item style={{ marginRight: '1em' }}>
                              <Button
                                variant='text'
                                fullWidth
                                color='primary'
                                className='font-weight-bold text-break'
                                size='small'
                                style={{ fontSize: '12px' }}
                                onClick={() => handleQuickFilter({ username: capture.username })}
                              >
                                {capture.username}
                              </Button>
                            </Grid>
                          </Grid>)
                        : (
                          <Typography variant='body2'>N/A</Typography>)
                    }
                  </Grid>
                </Grid>
                {/* User End */}
              </ListItem>

              <Divider variant='middle' />

              <ListItem disableGutters>
                {/* Phrase/Phrases Start */}
                {
                  capture.multiple_phrases
                    ? (
                      <Grid item container direction='column' justify='center' className='w-100 mx-auto'>
                        <Grid item container direction='row' justify='center'>
                          <Typography variant='body2' className=''>Phrases:</Typography>
                        </Grid>
                        <Grid item container direction='row' justify='center'>
                          {
                            violationAdditionalTerms.length
                              ? violationAdditionalTerms.map((addtlPhrase, idx) => (
                                <Button
                                  key={`addtlphrase${idx}`}
                                  variant='text'
                                  fullWidth
                                  color='primary'
                                  classes={{ root: classes.phraseButton }}
                                  size='small'
                                  style={{ fontSize: '12px' }}
                                  // es was not engineered to handle multi phrase searching, will need to wait to enable this action until this can be re-worked
                                  disabled
                                // onClick={() => handleQuickFilter({ phrase: addtlPhrase.phrase })}
                                >
                                  {addtlPhrase.phrase} - {addtlPhrase.severity}
                                </Button>))
                              : (
                                <Typography variant='body2'>None</Typography>)
                          }
                        </Grid>
                      </Grid>)
                    : (
                      <Grid item container direction='column' justify='center' className='w-100 mx-auto'>
                        <Grid item container direction='row' justify='center'>
                          <Typography variant='body2' className=''>Word/Phrase:</Typography>
                        </Grid>
                        <Grid item container direction='row' justify='center'>
                          {
                            capture.phrase
                              ? (
                                <Button
                                  variant='text'
                                  fullWidth
                                  color='primary'
                                  className='font-weight-bold'
                                  size='small'
                                  style={{ fontSize: '12px' }}
                                  onClick={() => handleQuickFilter({ phrase: capture.phrase })}
                                >
                                  {capture.phrase}
                                </Button>)
                              : (
                                <Typography variant='body2'>N/A</Typography>)
                          }
                        </Grid>
                      </Grid>)
                }
                {/* Phrase/Phrases End */}
              </ListItem>

              <Divider variant='middle' />

              <ListItem disableGutters>
                <Grid item container direction='column' justify='center' className='w-100 mx-auto my-auto'>
                  <Grid item>
                    <Typography align='center' variant='body2'>Machine Time:</Typography>
                  </Grid>
                  <Grid item container direction='row' justify='center' spacing={1}>
                    <Grid item>
                      <Typography variant='subtitle2' align='center' className='text-muted'>{moment.unix(reportedAt / 1000).format('MM/DD/YYYY')}</Typography>
                    </Grid>
                    <Grid item>
                      <Typography variant='subtitle2' align='center' className='text-muted'>{moment.unix(reportedAt / 1000).format('LT')}</Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </ListItem>

              <Divider variant='middle' />

              <ListItem disableGutters>
                {/* Source Start */}
                <Grid item container direction='column' justify='center'>
                  <Grid item container direction='row' justify='center'>
                    <Typography variant='body2' className=''>Source:</Typography>
                  </Grid>
                  <Grid item container direction='row' justify='center'>
                    {
                      getSourceDescription(capture.source)
                        ? (
                          <Button
                            variant='text'
                            fullWidth
                            color='primary'
                            className='font-weight-bold'
                            size='small'
                            style={{ fontSize: '12px' }}
                            onClick={() => handleQuickFilter({ source: capture.source })}
                          >
                            {getSourceDescription(capture.source)}
                          </Button>)
                        : (
                          <Typography variant='body2'>N/A</Typography>)
                    }
                  </Grid>
                </Grid>
                {/* Source End */}
              </ListItem>

              <Divider variant='middle' />

              <ListItem disableGutters>
                <Grid item container direction='column' justify='center' className='w-100 my-auto'>
                  <Grid item>
                    <Typography align='center' variant='body2'>Console Time:</Typography>
                  </Grid>
                  <Grid item container direction='row' justify='center' spacing={1}>
                    <Grid item>
                      <Typography variant='subtitle2' align='center' className='text-muted'>{moment.unix(receivedAt / 1000).format('MM/DD/YYYY')}</Typography>
                    </Grid>
                    <Grid item>
                      <Typography variant='subtitle2' align='center' className='text-muted'>{moment.unix(receivedAt / 1000).format('LT')}</Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </ListItem>

              <Divider variant='middle' />

              <ListItem disableGutters>
                {/* Category Start */}
                <Grid item container direction='column' justify='center' className='w-100 my-auto'>
                  <Grid item container direction='row' justify='center'>
                    <Typography variant='body2' className=''>Category:</Typography>
                  </Grid>
                  <Grid item container direction='row' justify='center'>
                    {
                      capture.categoryName
                        ? (
                          <Button
                            variant='text'
                            fullWidth
                            color='primary'
                            className='font-weight-bold'
                            size='small'
                            style={{ fontSize: '12px' }}
                            onClick={() => handleQuickFilter({ categoryName: capture.categoryName })}
                          >
                            {capture.categoryName}
                          </Button>)
                        : (
                          <Typography variant='body2'>N/A</Typography>)
                    }
                  </Grid>
                </Grid>
                {/* Category End */}
              </ListItem>

              <Divider variant='middle' />

              <ListItem disableGutters>
                <Grid item container direction='column' justify='center' className='w-100 mx-auto my-auto'>
                  <Grid item>
                    <Typography variant='body2' align='center'>Received Time:</Typography>
                  </Grid>
                  <Grid item container direction='row' justify='center' spacing={1}>
                    <Grid item>
                      <Typography variant='subtitle2' align='center' className='text-muted'>{moment.unix(receivedAt / 1000).format('MM/DD/YYYY')}</Typography>
                    </Grid>
                    <Grid item>
                      <Typography variant='subtitle2' align='center' className='text-muted'>{moment.unix(receivedAt / 1000).format('LT')}</Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </ListItem>

              <Divider variant='middle' />

              <ListItem disableGutters>
                {/* IP Address Start */}
                <Grid item container direction='column' className='w-100 mx-auto my-auto' justify='center'>
                  <Grid item container direction='row' justify='center'>
                    <Typography variant='body2' className=''>IP Addr:</Typography>
                  </Grid>
                  <Grid item container direction='row' justify='center'>
                    <Typography variant='body2'>{ipAddress}</Typography>
                  </Grid>
                </Grid>
                {/* IP Address End */}
              </ListItem>

              <Divider variant='middle' />

              {/* Note by CC: LS requested removal of location link on 10/14/2021 */}
              <ListItem disableGutters>
                {/* Location Start */}
                <Grid item container direction='column' justify='center' className='w-100 mx-auto my-auto'>
                  <Grid item container direction='row' justify='center'>
                    <Typography variant='body2' className=''>Location:</Typography>
                  </Grid>
                  <Grid item container direction='row' justify='center'>
                    <Typography variant='caption' style={{ textAlign: 'center' }}>{renderUnit(capture)}</Typography>
                  </Grid>
                </Grid>
                {/* Location End */}
              </ListItem>

              <Divider variant='middle' />

              <ListItem disableGutters>
                {/* Machine Start */}
                <Grid item container direction='column' justify='center' className='w-100 mx-auto my-auto'>
                  <Grid item container direction='row' justify='center'>
                    <Typography variant='body2' className=''>Station:</Typography>
                  </Grid>

                  <Grid item container direction='row' justify='center'>
                    {
                      capture?.workstationName
                        ? (
                          <Grid item container justify='center' alignItems='flex-start'>
                            <Grid item>
                              {renderCopyButton(capture.workstationName, copyTypes.WORKSTATION)}
                            </Grid>

                            <Grid item>
                              <Button
                                variant='text'
                                fullWidth
                                color='primary'
                                className='font-weight-bold'
                                size='small'
                                style={{ fontSize: '12px' }}
                                onClick={() => handleQuickFilter({ workstationName: capture.workstationName })}
                              >
                                {capture.workstationName}
                              </Button>
                            </Grid>
                          </Grid>)
                        : (
                          <Grid>
                            <Typography variant='body2'>N/A</Typography>
                          </Grid>)
                    }
                  </Grid>

                </Grid>
                {/* Machine End */}
              </ListItem>

              <Divider variant='middle' />

              <ListItem disableGutters>

                {/* Application Start */}
                <Grid item container direction='column' justify='center' className='w-100 mx-auto my-auto'>
                  <Grid item container direction='row' justify='center'>
                    <Typography variant='body2' className=''>Application:</Typography>
                  </Grid>
                  <Grid item container direction='row' justify='center'>
                    {
                      capture.applicationName
                        ? (
                          <Button
                            variant='text'
                            fullWidth
                            color='primary'
                            className='font-weight-bold'
                            size='small'
                            style={{ fontSize: '12px' }}
                            onClick={() => handleQuickFilter({ applicationName: capture.applicationName })}
                          >
                            {truncateText(capture.applicationName)}
                          </Button>)
                        : (
                          <Typography variant='body2'>N/A</Typography>)
                    }
                  </Grid>
                </Grid>
                {/* Application End */}
              </ListItem>

              <Divider variant='middle' />

              <ListItem disableGutters>
                <Grid item container direction='column' alignItems='center'>
                  <Grid item container direction='row' justify='center'>
                    <Typography variant='body2'>Website:</Typography>
                  </Grid>

                  <Grid item container direction='row' justify='center'>
                    {
                      capture?.websiteUrl
                        ? (
                          <Grid item container justify='center' alignItems='flex-start'>
                            <Grid item>
                              {renderCopyButton(capture.websiteUrl, copyTypes.URL)}
                            </Grid>

                            <Grid item>
                              <Tooltip title={capture.websiteUrl} arrow>
                                <Typography variant='subtitle2' align='center' className='text-muted'>{truncateText(capture.websiteUrl)}</Typography>
                              </Tooltip>
                            </Grid>
                          </Grid>)
                        : (
                          <Grid>
                            <Typography variant='body2'>N/A</Typography>
                          </Grid>)
                    }
                  </Grid>

                  {
                    capture.websiteUrl && canRequestBlock
                      ? captureUrlStatus !== null
                        ? (
                          <Grid item container direction='row' style={{ justifyContent: 'center', margin: '.4em 0' }}>
                            <Tooltip title={getUrlStatusTooltip(captureUrlStatus)} arrow>
                              <Typography
                                // variant='text'
                                color='primary'
                                className='font-weight-bold'
                                size='small'
                                style={{ fontSize: '12px' }}
                              >
                                {getCaptureUrlStatus()}
                              </Typography>
                            </Tooltip>
                          </Grid>)
                        : (
                          <Grid item style={{ marginTop: '.5em' }}>
                            <Button
                              variant='contained'
                              color='primary'
                              disabled={isDomainBlocked || isIPAddressCheck(capture?.websiteUrl)}
                              onClick={(e) => {
                                e.preventDefault()
                                onRequestBlock()
                              }}
                              style={{ textTransform: 'none', fontWeight: 'bold', lineHeight: '1.3' }}
                              classes={{ containedPrimary: classes.buttonColor }}
                              fullWidth
                            >
                              Request Block
                            </Button>
                          </Grid>)
                      : (<></>)
                  }
                </Grid>
              </ListItem>

              <Divider variant='middle' />

              <ListItem disableGutters>
                <Grid container direction='row' justify='center' spacing={2} className='w-100 mx-auto'>
                  <Grid item container direction='column' xs={12} justify='center'>
                    <Grid item container direction='row' justify='center'>
                      <Typography variant='body2' className=''>Capture ID:</Typography>
                    </Grid>
                    <Grid item container direction='row' justify='center'>
                      <Typography gutterBottom className='text-muted text-break' style={{ fontSize: '.7rem', textAlign: 'center' }}>{capture.violationID}</Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </ListItem>
            </List>
          </Grid>
        </CardContent>
      </Card>

      <PartialQuarantineModal
        classes={classes}
        partialQuarantineOpen={partialQuarantineOpen}
        closePartialQuarantineModal={closePartialQuarantineModal}
        baseImageDataStr={baseImageDataStr}
        capture={capture}
        handlePartialQuarantine={handlePartialQuarantine}
      />
    </>
  )
}

export default DetailsSidebar
